import React from 'react';
import {Link} from 'react-router-dom';
import backIcon from '../assets/icon-arrow.svg';
import './BackButton.css';

const backRoute = currentRoute =>
    currentRoute.indexOf('/high-definition-optics/impact-protection/') === 0
        ? '/high-definition-optics/impact-protection'
        : '/';

export const BackButton = props => (
    <div className="BackButton">
        <div className="BackButton-content">
            <Link to={backRoute(props.location.pathname)}>
                <div className="BackButton-icon">
                    <img src={backIcon} alt="" />
                </div>
                <span className="hidden">Indietro</span>
            </Link>
        </div>
    </div>
);

export default BackButton;



// WEBPACK FOOTER //
// ./src/atoms/BackButton.js